/**
 * DEMO_AMENITIES — Iter-110 · Item 8.
 * Professionally curated, read-only amenity sets per property type shown on
 * every demo form and auto-applied to the prospect's demo launch board.
 * Quantities reflect a realistic mid-size commercial property of each type.
 */
export const DEMO_AMENITIES = {
  residential: [
    { name: 'Trash Rooms', qty: 6 },
    { name: 'Trash Chutes', qty: 3 },
    { name: 'Compactors', qty: 2 },
    { name: 'Dumpster Pads', qty: 4 },
    { name: 'Recycling Stations', qty: 6 },
    { name: 'Mail & Package Room', qty: 1 },
    { name: 'Clubhouse / Leasing Lounge', qty: 1 },
    { name: 'Fitness Center', qty: 1 },
    { name: 'Study Room', qty: 1 },
    { name: 'Pool Deck', qty: 1 },
    { name: 'Dog Waste Stations', qty: 8 },
    { name: 'Dog Park', qty: 1 },
    { name: 'Pet Spa', qty: 1 },
  ],
  office: [
    { name: 'Lobbies', qty: 2 },
    { name: 'Elevator Banks', qty: 3 },
    { name: 'Restroom Sets', qty: 8 },
    { name: 'Conference Rooms', qty: 6 },
    { name: 'Break Rooms / Kitchenettes', qty: 4 },
    { name: 'Executive Suites', qty: 10 },
    { name: 'Common Corridors', qty: 12 },
    { name: 'Stairwells', qty: 4 },
    { name: 'Loading Dock', qty: 1 },
    { name: 'Parking Garage Levels', qty: 3 },
  ],
  retail: [
    { name: 'Storefront Entrances', qty: 12 },
    { name: 'Sidewalk & Walkway Zones', qty: 8 },
    { name: 'Shared Restroom Sets', qty: 2 },
    { name: 'Parking Lot Zones', qty: 4 },
    { name: 'Cart Corrals', qty: 6 },
    { name: 'Trash Enclosures', qty: 3 },
    { name: 'Landscape Beds', qty: 10 },
    { name: 'Loading Zones', qty: 4 },
  ],
  gas_station: [
    { name: 'Fuel Pump Islands', qty: 8 },
    { name: 'Forecourt Canopy', qty: 1 },
    { name: 'Restrooms', qty: 2 },
    { name: 'Sales Floor', qty: 1 },
    { name: 'Coffee / Fountain Station', qty: 1 },
    { name: 'Cooler Aisles', qty: 4 },
    { name: 'Trash & Windshield Stations', qty: 8 },
    { name: 'Dumpster Enclosure', qty: 1 },
    { name: 'Air / Vacuum Station', qty: 1 },
  ],
  school: [
    { name: 'Classrooms', qty: 24 },
    { name: 'Gymnasium', qty: 1 },
    { name: 'Cafeteria', qty: 1 },
    { name: 'Library / Media Center', qty: 1 },
    { name: 'Restroom Sets', qty: 10 },
    { name: 'Administrative Offices', qty: 6 },
    { name: 'Locker Bays', qty: 4 },
    { name: 'Auditorium', qty: 1 },
    { name: 'Playground / Field Areas', qty: 2 },
    { name: 'Entry Vestibules', qty: 3 },
  ],
  medical: [
    { name: 'Exam Rooms', qty: 12 },
    { name: 'Waiting Areas', qty: 2 },
    { name: 'Reception Desks', qty: 2 },
    { name: 'Restrooms', qty: 6 },
    { name: 'Laboratory', qty: 1 },
    { name: 'Sterilization Room', qty: 1 },
    { name: 'Nurse Stations', qty: 3 },
    { name: 'Biohazard Collection Points', qty: 4 },
    { name: 'Staff Break Room', qty: 1 },
    { name: 'Consultation Offices', qty: 5 },
  ],
  warehouse: [
    { name: 'Office Pod', qty: 1 },
    { name: 'Break Rooms', qty: 2 },
    { name: 'Restroom Sets', qty: 4 },
    { name: 'Locker Rooms', qty: 2 },
    { name: 'Loading Docks', qty: 8 },
    { name: 'Warehouse Floor Zones', qty: 6 },
    { name: 'Mezzanine', qty: 1 },
    { name: 'Security Booth', qty: 1 },
    { name: 'Equipment Charging Bays', qty: 4 },
    { name: 'Exterior Grounds Zones', qty: 2 },
  ],
  restaurant: [
    { name: 'Dining Room Zones', qty: 3 },
    { name: 'Kitchen Line', qty: 1 },
    { name: 'Prep Stations', qty: 4 },
    { name: 'Walk-in Coolers', qty: 2 },
    { name: 'Restrooms', qty: 2 },
    { name: 'Bar Area', qty: 1 },
    { name: 'Host Stand & Entry', qty: 1 },
    { name: 'Patio Seating', qty: 1 },
    { name: 'Grease Trap & Hood System', qty: 1 },
    { name: 'Dumpster Corral', qty: 1 },
  ],
  mall: [
    { name: 'Anchor Court Entrances', qty: 4 },
    { name: 'Common Area Concourses', qty: 6 },
    { name: 'Food Court', qty: 1 },
    { name: 'Restroom Sets', qty: 8 },
    { name: 'Family Lounge', qty: 1 },
    { name: 'Escalator Banks', qty: 4 },
    { name: 'Elevator Cabs', qty: 6 },
    { name: "Children's Play Area", qty: 1 },
    { name: 'Parking Structure Levels', qty: 4 },
    { name: 'Service Corridors', qty: 10 },
  ],
  church: [
    { name: 'Sanctuary', qty: 1 },
    { name: 'Fellowship Hall', qty: 1 },
    { name: 'Kitchen', qty: 1 },
    { name: 'Classrooms / Sunday School Rooms', qty: 8 },
    { name: 'Nursery', qty: 1 },
    { name: 'Restroom Sets', qty: 4 },
    { name: 'Lobby / Narthex', qty: 1 },
    { name: 'Administrative Offices', qty: 3 },
    { name: 'Choir & Media Rooms', qty: 2 },
    { name: 'Parking Lot Zones', qty: 2 },
  ],
};

export default DEMO_AMENITIES;
